module.exports = __webpack_public_path__ + "img/logo.34f5cbe7.png";